const getNavigator = () => {
  if (typeof navigator !== 'undefined') return navigator
  if (typeof window !== 'undefined') return window.navigator
  return undefined
}

const getWindow = () => {
  return typeof window !== 'undefined' ? window : undefined
}

export const isMac = () => /Mac/.test(getNavigator()?.platform ?? '')
export const isSafari = () =>
  (getNavigator()?.vendor ?? '') === 'Apple Computer, Inc.'
export const isIOS = () => {
  const nav = getNavigator()
  const win = getWindow()
  if (!nav || !win) return false
  return (
    /iPad|iPhone|iPod/.test(nav.userAgent) &&
    // @ts-ignore
    !win.MSStream &&
    isSafari()
  )
}
export const isAndroid = () => /android/i.test(getNavigator()?.userAgent ?? '')

// FIXME: Avoid duplication
const ANDROID_BRIDGE_NAME = 'pixaiAppBridge'
export function isIOSWebview() {
  if (!isIOS()) return false
  return (
    typeof window.webkit?.messageHandlers?.nativeBridge?.postMessage ===
    'function'
  )
}

export function isAndroidWebview() {
  if (!isAndroid()) return false
  const win = getWindow()
  if (!win) return false
  const bridge = win[ANDROID_BRIDGE_NAME]
  return typeof bridge?.postMessage === 'function'
}

export function isAppWebview() {
  return isIOSWebview() || isAndroidWebview()
}
